import { render, staticRenderFns } from "./addIp.vue?vue&type=template&id=007322be&lang=pug&"
import script from "./addIp.vue?vue&type=script&lang=js&"
export * from "./addIp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports